import { User, useToggle } from '@alluradirect/react';
import { AlluraFormikErrorMessage } from 'components/formik/core/AlluraErrorMessage/AlluraFormikErrorMessage';
import styled from 'styled-components';
import { CheckoutMissingInfoDialog } from 'components/views/pages/Checkout/CheckoutStep1/components/CheckoutMissingInfoDialog/CheckoutMissingInfoDialog';
import { UserMissingProfileInfoReturn } from 'helpers/userHelpers';
import { useLocationDetails } from 'hooks/api/useLocationDetails';
import { BookingSettingsItem } from './BookingSettingsItem';
import { Box } from '@mui/material';

export const WarningWrapper = styled(Box)`
  padding: ${props => props.theme.spacing(2)};
  padding-top: ${props => props.theme.spacing(1.5)};
  background-color: ${props => props.theme.palette.warning.lightest};
  border-radius: 5px;
`;

interface Props {
  isLoading: boolean;
  user: User | undefined;
  missingInfo: UserMissingProfileInfoReturn | undefined;
}

export const CheckoutMissingInfo = ({ isLoading, user, missingInfo }: Props) => {
  const toggleMissingInfo = useToggle();

  const locationDetails = useLocationDetails({
    guestId: user?.ID ?? 0,
    isOwnerApp: false,
    enabled: Boolean(user),
  });

  return (
    <>
      <WarningWrapper>
        <BookingSettingsItem
          title="Missing account information"
          value="Please review and complete the required information about yourself"
          onClick={toggleMissingInfo.open}
          disabled={false}
          isLoading={isLoading}
          buttonText="Update"
          hasWarning={true}
        />
      </WarningWrapper>
      <AlluraFormikErrorMessage fieldName={'hasFilledRequiredInfo'} />

      {toggleMissingInfo.isOpen && missingInfo && user ? (
        <CheckoutMissingInfoDialog
          isOpen={toggleMissingInfo.isOpen}
          close={toggleMissingInfo.close}
          missingInfo={missingInfo}
          user={user}
          locationDetails={locationDetails.data}
          // disableClose={false}
          // userId={userData.ID}
          // isGuestApp={true}
          // hasSecurityTab={false}
        />
      ) : null}
    </>
  );
};
